<div class="container mt-4">
    <div class="card shadow-sm border-0">
      <div class="card-body" style="min-height: 220px;">
        <div class="mb-3">
          <label for="remarkTextarea" class="form-label">Remark</label>
          <textarea class="form-control" [(ngModel)]="remark" id="remarkTextarea" rows="4" placeholder="Enter your remark here..."></textarea>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <button type="button" class="btn btn-secondary me-2" (click)="closeDialog();">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
        </div>
      </div>
    </div>
  </div>
  